<template>
  <div>公共服务平台</div>
</template>
<script>
export default {
  
}
</script>
<style lang="less" scoped>

</style>